/**
 * DocumentSetEventEntityName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventEntityName from '../../../../components/EventEntityName';

// Selectors
import { makeSelectDocumentSetValue } from '../../../../services/documentSets/selectors';

interface Props {
    eventId?: number;
}

export class DocumentSetEventEntityName extends React.PureComponent<Props> {
    render() {
        const { eventId } = this.props;
        if (!eventId) return null;
        return <EventEntityName eventId={eventId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(DocumentSetEventEntityName);
